var exports = {
  "l": "confirm__2SzKPs",
};

module.exports = exports;
